import CrudCustom from '../../../libs/custom/CrudCustom';

let PengaturanPenghasilanSptService = new CrudCustom('/tipe-penghasilan-lamp-1771-iis');
export default PengaturanPenghasilanSptService;
